module.exports = __webpack_public_path__ + "static/media/righttn.7f4fdfc7.png";